export default "__VITE_ASSET__Ij4Ii2U3cz0dqyeOEwXe4g__"